<template>
 <gg-card>
   <gg-card-header>
     Products & Services
   </gg-card-header>
   <gg-card-text>
     <v-row>
       <v-col cols="12">
         <p>
           Enter the details of up to 6 products or services that you offer. If you don’t have any or would
           like to add this information later, click Next Step.
         </p>
         <template v-for="(service, index) in starterSite.contentServices">
           <v-textarea
             :value="service"
             @change="setService($event, index)"
             :key="`ps-${index}`"
             placeholder="Provide content for Your Website's Services or Products Section"
             rows="3"
             outlined
             dense
             hide-details
             class="mb-4"
           />
         </template>
       </v-col>
       <v-col cols="12">
         <gg-btn
           v-show="starterSite.contentServices.length < maxServices"
           secondary
           @click="addService"
         >Add Item</gg-btn>
       </v-col>
     </v-row>
   </gg-card-text>
 </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'WebsiteProducts',
  data () {
    return {
      maxServices: 6
    }
  },
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite'
    })
  },
  methods: {
    ...mapMutations({
      setServices: 'wizard_model/SET_SS_CONTENT_SERVICES'
    }),
    addService () {
      if (this.starterSite.contentServices.length < this.maxServices) {
        this.setServices([...this.starterSite.contentServices, ''])
      }
    },
    setService (val, index) {
      const copy = this.starterSite.contentServices.slice()
      copy[index] = val
      this.setServices(copy)
    },
    validate () {
      return true
    }
  }
}
</script>

<style scoped>

</style>
